module.exports = __webpack_public_path__ + "static/media/wop.449f22d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/web-development/wop.png
// module id = 171
// module chunks = 0